import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "layout__search-results" }
const _hoisted_2 = { class: "layout__search-results-header" }
const _hoisted_3 = {
  key: 0,
  class: "layout__search-recent"
}
const _hoisted_4 = {
  key: 0,
  class: "layout__search-no-recent"
}
const _hoisted_5 = {
  key: 0,
  class: "layout__search-results-container-mobile"
}
const _hoisted_6 = {
  key: 3,
  class: "layout__search-results-container"
}

import ListStandard from '@/design-system/molecules/ListStandard.vue'
import IconHomeWork from '@/design-system/assets/icons/IconHomeWork.vue'
import IconRealEstate from '@/design-system/assets/icons/IconRealEstate.vue'
import IconHome from '@/design-system/assets/icons/IconHome.vue'
import IconMeetingRoom from '@/design-system/assets/icons/IconMeetingRoom.vue'
import IconHistory from '@/design-system/assets/icons/IconHistory.vue'
import IconLocationOn from '@/design-system/assets/icons/IconLocationOn.vue'
import TabsUnderlineMenu from '@/design-system/molecules/TabsUnderlineMenu.vue'
import LayoutSearchState from '@/design-system/molecules/LayoutSearchState.vue'
import { getRealmId } from '@/utils/realmId'
import { PropType, toRefs, ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import ListItemLoading from '@/design-system/atoms/ListItemLoading.vue'
import { ResultObject } from '@/interfaces/search.interface'

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutSearchResults',
  props: {
  searchResults: {
    type: Object,
    default: () => {}
  },
  isTyping: {
    type: Boolean,
    default: false
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  isIndoorviewShowing: {
    type: Boolean,
    default: false
  },
  recentSearch: {
    type: Array as PropType<Array<any>>,
    default: () => []
  },
  searchString: {
    type: String,
    default: ''
  },
  mobileScreen: {
    type: Boolean,
    default: false
  }
},
  emits: ["selectedBuilding", "selectedComplex", "selectedRealEstate", "selectedRoom"],
  setup(__props, { emit: __emit }) {

const props = __props
const { searchResults, isIndoorviewShowing, recentSearch, mobileScreen, isTyping } = toRefs(props)

// Emits (defineEmits)
const emits = __emit

// reactive variables etc
const { t } = useI18n()
const store = useStore()
const currentBuilding = store.state.mapview.selectedBuilding.name
const realmId = getRealmId()
const error = ref<boolean>(false)
const empty = ref<boolean>(true)

// computed
const data = computed<Array<any>>(() => {
  const complexData = {
    title: realmId === 'akademiskahus' ? t('title__complex__campus') : t('general__title__complex'),
    icon: IconHomeWork,
    items: searchResults.value.complexes
  }
  const realEstateData = {
    title: t('general__data__realestates'),
    icon: IconRealEstate,
    items: searchResults.value.realEstates
  }
  const buildingData = {
    title: t('general__data__buildings'),
    icon: IconHome,
    items: searchResults.value.buildings
  }
  const roomData = {
    title: t('general__data__rooms'),
    icon: IconMeetingRoom,
    items: searchResults.value.rooms
  }
  const poiData = {
    title: t('general__text__pois-v2'),
    icon: IconLocationOn,
    items: searchResults.value.pois
  }
  return isIndoorviewShowing.value
    ? [poiData, roomData]
    : [complexData, realEstateData, buildingData, roomData]
})
const totalResultsCount = computed(() => {
  let dataCount = 0
  data.value.forEach((object) => {
    dataCount += object.items.length
  })
  return dataCount
})

// methods
function onSelect(item) {
  switch (item.type) {
    case 'COMPLEX':
      emits('selectedComplex', item)
      break
    case 'REAL_ESTATE':
      emits('selectedRealEstate', item)
      break
    case 'BUILDING':
      emits('selectedBuilding', item)
      break
    case 'ROOM':
      emits('selectedRoom', item)
      break
  }
}

watch(totalResultsCount, (newCount) => {
  if (newCount === 0) {
    empty.value = true
  } else empty.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(isTyping) && empty.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(IconHistory),
            _createTextVNode(" " + _toDisplayString(_unref(t)('general__text__search-recent')), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_unref(isIndoorviewShowing)
            ? `${_unref(t)('general__text__search-results-for')} ${_unref(currentBuilding)} (${totalResultsCount.value})`
            : `${_unref(t)('general__text__search-results')} (${
                __props.isLoading ? _unref(t)('general__text__in-progress') : totalResultsCount.value
              })`), 1)
          ], 64))
    ]),
    (!_unref(isTyping) && empty.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_unref(recentSearch).length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('general__text__search-no-recent')), 1))
            : (_openBlock(), _createBlock(ListStandard, {
                key: 1,
                items: _unref(recentSearch),
                onSelect: onSelect
              }, null, 8, ["items"]))
        ]))
      : _createCommentVNode("", true),
    (_unref(isTyping))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(mobileScreen))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(TabsUnderlineMenu, {
                  tabItems: data.value,
                  isLoading: __props.isLoading,
                  searchString: __props.searchString,
                  onSelect: onSelect
                }, null, 8, ["tabItems", "isLoading", "searchString"]),
                (__props.isLoading)
                  ? (_openBlock(), _createBlock(ListItemLoading, {
                      key: 0,
                      itemsToRender: 10
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (empty.value && !__props.isLoading)
            ? (_openBlock(), _createBlock(LayoutSearchState, {
                key: 1,
                empty: true,
                searchString: __props.searchString
              }, null, 8, ["searchString"]))
            : (error.value && !__props.isLoading && !empty.value)
              ? (_openBlock(), _createBlock(LayoutSearchState, {
                  key: 2,
                  error: true
                }))
              : (!_unref(mobileScreen))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (object, index) => {
                      return (_openBlock(), _createBlock(ListStandard, {
                        key: object + index,
                        class: "layout__search-results-list",
                        icon: object.icon,
                        title: object.title,
                        items: object.items,
                        isLoading: __props.isLoading,
                        hasTooltips: true,
                        onSelect: onSelect
                      }, {
                        default: _withCtx(() => [
                          (__props.isLoading)
                            ? (_openBlock(), _createBlock(ListItemLoading, {
                                key: 0,
                                itemsToRender: 9
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["icon", "title", "items", "isLoading"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})